// extracted by mini-css-extract-plugin
module.exports = {"tags":"AllSpeakers_tags__39kQ0"};